import React from 'react';
import '../../styles/components/common/LoadingScreen.css'

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="loading-animation">
        <div className="loading-car">
          <div className="car-body"></div>
          <div className="car-wheel wheel-1"></div>
          <div className="car-wheel wheel-2"></div>
        </div>
        <div className="wash-bubbles">
          <div className="bubble"></div>
          <div className="bubble"></div>
          <div className="bubble"></div>
        </div>
      </div>
      <p>Pripremanje ClickWash iskustva...</p>
    </div>
  );
};

export default LoadingScreen;